<template>
  <div class="dlrLayer slideMiddle_in" v-if="dealerList.length > 0">
    <div class="dlrLayer-middle dlrLayer-shops">
      <div class="dlrLayer-shops-list">
        <span class="dlrLayer-shops-close" @click="closeDeals">关闭</span>
        <div class="dlrLayer-shops-title">请先选择店铺</div>
        <ul class="dlrLayer-shops-ul">
          <li
            class="dlrLayer-shops-item"
            v-for="item in dealerList"
            @click="toHall(item.dealerId)"
            :key="item.dealerId"
          >
            <a href="javascript:void(0);">{{ item.dealerSimpleName }} </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="dlrLayer-mask" @click="closeDeals"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import vrShowApi from '@/apis/vr.show.api';
import VRICSAppService from '@/services/vrShow/vr.ics.app.service.js';
import { hideLoading } from '../services/loading.service';
export default {
  name: 'IcsAppEntrance',
  data () {
    return {
      dealerList: []
    };
  },
  computed: {
    ...mapGetters({
      icsRecordsSalerInfo: 'sales/icsRecordsSalerInfo',
    }),
    salesId () {
      return this.icsRecordsSalerInfo.salesId;
    }
  },
  mounted () {
    // 隐藏
    this.$store.commit('busiIcsApp/SET_ICS_STATUS', { icsShowState: 0 });
    const dealerids = this.$queryParams.dealerIds;
    this.initDealList(dealerids);
  },
  methods: {
    initDealList (dealerIds) {
      hideLoading();
      // 如果登录顾问只服务于一家店铺，直接跳转到对应展厅
      if (dealerIds.indexOf(',') === -1) {
        this.toHall(dealerIds);
        return false;
      }
      vrShowApi.getList({ dealerIds }).then((res) => {
        if (res.returncode === 0 && res.result) {
          this.dealerList = res.result;
        } else {
          console.warn(res.message);
        }
      }).catch((ex) => {
        console.error(ex);
      });
    },
    toHall (dealerId) {
      const pvareaid = this.$route.query.pvareaid;
      this.$router.replace({ path: `/${dealerId}/dealerm/index.html`, query: { pvareaid, busi: 'ics' } });
    },
    closeDeals () {
      const icsAppService = new VRICSAppService();
      icsAppService.appClose();
    }
  }
};
</script>

<style lang="scss">
.dlrLayer-shops {
  position: relative;
  width: ptrd(560);
  background: #fff;
  border-radius: ptrd(16);
  padding: ptrd(40);
  box-sizing: border-box;

  & ~ .dlrLayer-mask {
    background-color: #999999;
  }

  &-close {
    position: absolute;
    top: ptrd(30);
    right: ptrd(30);
    width: ptrd(32);
    height: ptrd(32);
    font-size: 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAADvElEQVRYR82YTWhcVRTH/+fOZKBZZcBFGluFaqqQCtKVi1rdqAuRFIQhgqUmM+9ccFlpEZGKpRRaq7i99yUz0EWtEbHFL6q4CCbgRjehi9ISxI/YjcRVhUxyj9zkvTCZvDdvZvIIPpjN3HvP/d17Pu45h9DHZ4x5RCl1yDk3QkQjXoSILCullp1zS1rr33oVS90usNaOAXhVRE4AGAZwl4iWAfif/0ZExEONArhPRDcAfM7Mt7vZIxOkXq8fXFtbOy8iLxHRdaXUjWq1Ok9ELmkDEVEzMzPHnHMnRGSCiG4Vi8VzU1NTv3cC6ggShuEZ59xZpZRxzl3UWj/o5nTxHGPMoFLqHeecJqJLzHwlbX0iiD9VGIYNETlSKpVenpycvN8LQPvcRqMxvLq6+g0RLYpITWvdbJ+zA8QYM0BEd0Xk0XK5PFipVP7dDUS8dnZ2dt/KyspnAMaY+bF21e4AsdZeBVBm5lfyAGiXYYwRIrrKzKdax7aBRDYxUS6Xj+V1E+0g0c0sENG1VpvZAvHe0Ww2fymVSk/t1iaybjKymcWBgYGjsTdtgVhrG0T0ZxAE72YJymM8DMMLIvIwM096eRsgPliJyPcAHk9zUWPMQ4VC4YlarbbQLYgx5slisSjVavVOgq0MArhHRC/4oBeDnAMwxMyn0zap1+uHms2m1+2bzPxFFoy19mkR+bZQKLxeq9V+SJpvrf0IwD/MfH4DxBjzMxGdZua5ThvEwrNgup03PT19fH19/WOt9VHyDxiAn5j5QFrYboXL2iRrvFWWD5zW2j8APENhGD7vnHtfa/1c1nXH42mb9QLR8gzMKaXe8yCvOefGtdYT3YJEBr5hA7Ga+oGI5HwiIl961bxFRN6NUg01DTDeHMBlAGezbCfFYD8E8NeuQKITVQBcA3CFmd/u5Vaj9Zsg/aqmVT27vJFN1fRjrHnaiDFm01h7dd8kiCxvSlPXNvftJaB1gugHZltAi4RnhvhuIHqF2RHiowz9OxEZTXv08n5rfD6749GLTtsxDcj79U1MAzzI/yYx8jB7mCrOK6WuB0HwQWxXicmziJzUWmcWX71G0chDvyKivzsmz35iVNMsAVgcGhqq5JVER0mzL9B+BXC4vbZJPHVU28yIyFiOBdbXRHQ7CII3kvKePSs5lVKXW22iXa2ZdhAX4QBeBPApgJtBEPzYqQgPw/BZAOO5FeFtKWLclhgHsN+3JTae783WhLct35Lw//u2hP//Zq5tiSTPiBs1fmPfrPFzfJPGA/TbqPkPsqCuAyTq6jwAAAAASUVORK5CYII=);
    background-size: 100% 100%;
  }

  &-title {
    font-size: ptrd(30);
    color: #333;
    text-align: center;
    line-height: ptrd(36);
    font-weight: bold;
  }

  &-ul {
    margin-top: ptrd(34px);
  }

  &-item {
    & + .dlrLayer-shops-item {
      margin-top: ptrd(20px);
    }

    a {
      color: #333;
      display: block;
      line-height: ptrd(42px);
      padding: ptrd(30px) ptrd(50px);
      background: #f8f9fc;
      border-radius: ptrd(8px);
      text-align: center;
      font-size: ptrd(30px);

      &:active {
        background: #eef4ff;
        color: #0055cd;
        //  font-weight: bold;
      }
    }
  }
}
</style>
